/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import update from 'immutability-helper';

import { CarriesAppReduxActions } from './Action';
import { AuthenticationActions } from 'react-aad-msal';

export const carryAppState: CarriesApplicationState = {
    pageNum: {
        dashboard: 0,
        managePacket: 0,
    },
    zoom: {
        zoomRight: 20,
        zoomLeft: 20,
        zoomSingleRight: 20,
        zoomSingleLeft: 20,
    },
    solicitorViewer: {
        paketId: '',
    },
    tabId: '',
    visibilityState: true,
    isDuplicationRouter: false,
    hasIntializeAzure: false,
    isPageLeave: false,
    recordLocations: [],
};

const CarriesAppStateReducer = (
    state = carryAppState,
    action: any = { type: '', payload: {} }
): CarriesApplicationState => {
    switch (action.type) {
        case CarriesAppReduxActions.CARRIES_LOCATION_CHANGE:
            // eslint-disable-next-line no-case-declarations
            const { location, action: actionLocation } = (action.payload ||
                {}) as {
                location?: any | null;
                action?: any | null;
            };

            return update(state, {
                recordLocations: {
                    $splice: [[0, 0, { location, action: actionLocation }]],
                },
            });
        case AuthenticationActions.Initializing:
            return update(state, {
                $merge: {
                    hasIntializeAzure: false,
                },
            });
        case AuthenticationActions.AuthenticatedStateChanged:
        case AuthenticationActions.Initialized:
            return update(state, {
                $merge: {
                    hasIntializeAzure: true,
                },
            });
        case CarriesAppReduxActions.CARRIES_APP_SET_PACKET_PAGINATION:
            return update(state, {
                pageNum: {
                    $merge: {
                        managePacket: action.payload,
                    },
                },
            });
        case CarriesAppReduxActions.CARRIES_APP_SET_VISIBILITY_STATE:
            return update(state, {
                $merge: {
                    visibilityState: action.payload,
                },
            });
        case CarriesAppReduxActions.CARRIES_APP_SET_SINGLE_ZOOM_LEFT_DOCUMENT:
            return update(state, {
                zoom: {
                    $merge: {
                        zoomSingleLeft: action.payload,
                    },
                },
            });
        case CarriesAppReduxActions.CARRIES_APP_SET_SINGLE_ZOOM_RIGHT_DOCUMENT:
            return update(state, {
                zoom: {
                    $merge: {
                        zoomSingleRight: action.payload,
                    },
                },
            });
        case CarriesAppReduxActions.CARRIES_APP_SET_SOLICITOR_VIEWER_PACKETID:
            return update(state, {
                solicitorViewer: {
                    $merge: {
                        paketId: action.payload,
                    },
                },
                zoom: {
                    $merge: {
                        ...carryAppState.zoom,
                    },
                },
            });
        case CarriesAppReduxActions.CARRIES_APP_SET_ZOOM_RIGHT_DOCUMENT:
            return update(state, {
                zoom: {
                    $merge: {
                        zoomRight: action.payload,
                    },
                },
            });
        case CarriesAppReduxActions.CARRIES_APP_SET_ZOOM_LEFT_DOCUMENT:
            return update(state, {
                zoom: {
                    $merge: {
                        zoomLeft: action.payload,
                    },
                },
            });

        case CarriesAppReduxActions.CARRIES_APP_SET_SOLICITOR_VIEWER_DUPLICATION:
            return update(state, {
                $merge: {
                    isDuplicationRouter: action.payload,
                },
            });
        case CarriesAppReduxActions.CARRIES_APP_PAGE_LEAVE_STATE:
            return update(state, {
                $merge: {
                    isPageLeave: action.payload,
                },
            });
        case CarriesAppReduxActions.CARRIES_APP_TABID:
            return update(state, {
                $merge: {
                    tabId: action.payload,
                },
            });
        default:
            return state;
    }
};

export default CarriesAppStateReducer;
